"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxCreateToDoTaskFromMessageArgs = void 0;
function serializeHxCreateToDoTaskFromMessageArgs(_arg) {
    var output = [];
    output.push(_arg.subject);
    output.push(_arg.dueDate !== undefined);
    if (_arg.dueDate !== undefined) {
        output.push(_arg.dueDate.valueOf());
    }
    output.push(_arg.importance);
    return output;
}
exports.serializeHxCreateToDoTaskFromMessageArgs = serializeHxCreateToDoTaskFromMessageArgs;
